// extracted by mini-css-extract-plugin
export var container = "HomeProductLink-module--container--6Zvej";
export var content = "HomeProductLink-module--content--8obXM";
export var image = "HomeProductLink-module--image--M0AHX";